var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"html-editor"},[_c(_setup.VueQuillEditor,{ref:"editor",staticClass:"vue-quill-editor",attrs:{"options":_setup.quillOptions,"content":_vm.value},on:{"change":_setup.contentChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }